const General = (props) => {
    return(<></>)
}
export default General;